import { useState } from "react";
import { Phone, MessageCircle, Menu, X, ChevronDown } from "lucide-react";

const LINKS = [
  { label: "Sublimation", href: "/sublimation" },
  { label: "Why Us", href: "#why-us" },
  { label: "Gallery", href: "#gallery" },
  { label: "About Us", href: "#about" },
  { label: "Contact / RFQ", href: "#enquiry" },
];

export default function Header({ contact, onQuote, products = [] }) {
  const [open, setOpen] = useState(false);
  const [dropOpen, setDropOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0D0F12]/85 border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <a href="/" data-testid="nav-logo-link" className="bg-white rounded-xl px-3 py-1.5 shrink-0 hover:opacity-90 transition-opacity">
          <img src="/logo.png" alt="A-Z Concepts UK Ltd" className="h-9 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-links">
          <div className="relative" onMouseEnter={() => setDropOpen(true)} onMouseLeave={() => setDropOpen(false)}>
            <button type="button" data-testid="nav-link-products" onClick={() => setDropOpen(!dropOpen)}
              className="flex items-center gap-1 text-sm font-medium text-slate-300 hover:text-[#FF5A1F] transition-colors">
              Products <ChevronDown size={14} className={`transition-transform ${dropOpen ? "rotate-180" : ""}`} />
            </button>
            {dropOpen && (
              <div className="absolute top-full left-0 pt-3 z-50" data-testid="nav-products-dropdown">
                <div className="bg-[#161B22] border border-white/10 rounded-2xl p-2 w-72 shadow-xl shadow-black/50">
                  {products.map((p) => (
                    <a key={p.id} href={`/products/${p.id}`} data-testid={`nav-product-link-${p.id}`}
                      className="block px-4 py-2.5 rounded-xl text-sm text-slate-300 hover:text-white hover:bg-white/5 transition-colors">
                      {p.name}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.href.replace(/^[#/]+/, "")}`}
              className="text-sm font-medium text-slate-300 hover:text-[#FF5A1F] transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <a data-testid="nav-whatsapp-button" href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noreferrer"
            className="flex items-center gap-2 bg-[#25D366] hover:bg-[#1eb856] text-white text-sm font-bold rounded-full px-4 py-2 transition-colors">
            <MessageCircle size={16} /> WhatsApp
          </a>
          <a data-testid="nav-call-now-button" href={`tel:${contact.phone}`}
            className="flex items-center gap-2 text-sm font-semibold text-white border border-white/20 rounded-full px-4 py-2 hover:bg-white/10 transition-colors">
            <Phone size={16} /> {contact.phone}
          </a>
          <button data-testid="nav-get-quote-button" onClick={onQuote}
            className="bg-[#FF5A1F] hover:bg-[#E04810] text-white text-sm font-bold rounded-full px-5 py-2 transition-colors">
            Get Quote
          </button>
        </div>
        <button className="lg:hidden text-white p-2" data-testid="nav-mobile-menu-button" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 px-6 py-5 flex flex-col gap-4 max-h-[70vh] overflow-y-auto" data-testid="nav-mobile-drawer">
          <p className="text-xs font-bold uppercase tracking-wider text-[#FF5A1F]">Products</p>
          {products.map((p) => (
            <a key={p.id} href={`/products/${p.id}`} data-testid={`nav-mobile-product-link-${p.id}`}
              className="pl-3 text-sm font-medium text-slate-300 hover:text-[#FF5A1F] transition-colors">
              {p.name}
            </a>
          ))}
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${l.href.replace(/^[#/]+/, "")}`}
              className="text-base font-medium text-slate-200 hover:text-[#FF5A1F] transition-colors">
              {l.label}
            </a>
          ))}
          <div className="flex flex-wrap gap-3 pt-2">
            <a data-testid="nav-mobile-whatsapp-button" href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noreferrer"
              className="flex items-center gap-2 bg-[#25D366] text-white text-sm font-bold rounded-full px-4 py-2">
              <MessageCircle size={16} /> WhatsApp
            </a>
            <a data-testid="nav-mobile-call-button" href={`tel:${contact.phone}`}
              className="flex items-center gap-2 text-sm font-semibold text-white border border-white/20 rounded-full px-4 py-2">
              <Phone size={16} /> Call Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
